import React from 'react';
import { Styled, TableFilter } from '.';
import OrderSearch from 'components/Table/OrderSearch';
import { AiOutlineDownload } from 'react-icons/ai';

export const Table = ({ children }: { children: React.ReactNode }) => {
  return (
    <Styled.TableParent>
      <Styled.TableWrapper>{children}</Styled.TableWrapper>
    </Styled.TableParent>
  );
};

export const TableUtilities = ({
  availableStatuses,
  selectedShipmentStatusFilters,
  setSelectedShipmentStatusFilters,
  showOrderSearch,
}: {
  availableStatuses: string[];
  selectedShipmentStatusFilters: string[];
  setSelectedShipmentStatusFilters: React.Dispatch<
    React.SetStateAction<string[]>
  >;
  showOrderSearch?: boolean;
}) => {
  return (
    <Styled.TableUtilitiesWrapper>
      <TableFilter
        availableStatuses={availableStatuses}
        selectedShipmentStatusFilters={selectedShipmentStatusFilters}
        setSelectedShipmentStatusFilters={setSelectedShipmentStatusFilters}
      />
      {showOrderSearch ? <OrderSearch /> : null}
    </Styled.TableUtilitiesWrapper>
  );
};

export const THead = ({ children }: { children: React.ReactNode }) => (
  <thead>{children}</thead>
);

export const TRow = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick?: any;
}) => <Styled.TableRow onClick={onClick}>{children}</Styled.TableRow>;

export const THeadItem = ({
  children,
  width,
}: {
  children: React.ReactNode;
  width?: number;
}) => <Styled.TableHead width={width}>{children}</Styled.TableHead>;

export const TBody = ({ children }: { children: React.ReactNode }) => (
  <tbody>{children}</tbody>
);

export const TCell = ({ children }: { children: React.ReactNode }) => (
  <Styled.TableCell>{children}</Styled.TableCell>
);

export const TDownloadIcon = ({ onClick }: { onClick: () => void }) => (
  <Styled.DownloadIconContainer>
    <AiOutlineDownload onClick={onClick} size="24px" />
  </Styled.DownloadIconContainer>
);
